import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Input, Button, Dialog, DialogContent, DialogHeader, DialogTitle } from "src/shadcn/components/ui";
import bgImage from "../../../assets/blur_bg.png";
import { catchAsync, IS_SUCCESS_RESPONSE, PASSWORD_REGEX, successTheme, USER_ROLES } from "src/helpers";
import { getUserByTokenRequestApi, loginRequestApi, otpResentRequestApi, registrationRequestApi, verifyOtpRequestApi } from "src/services/requests/Auth";
import { AxiosResponse } from "axios";
import { toast } from "sonner";
import RoundedButton from "src/shadcn/components/custom/RoundedButton";
import { log } from "node:console";
import { setAuth, useAuth } from "src/modules/Auth/Core";
import { Loader2Icon } from "lucide-react";
import { axiosInstance } from "src/services/axiosSetup";


const PhoneNumberVerification: React.FC = () => {
    const [otpSent, setOtpSent] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [resentOtpisLoading, setresentOtpisLoading] = useState(false);
    const [canResend, setCanResend] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isUserExists, setisUserExists] = useState<"Registered" | "Not-Registered" | undefined>(undefined)
    const { setCurrentUser, saveAuth } = useAuth();
    const [previousPhoneNUmber, setpreviousPhoneNUmber] = useState<string>("")
    const [registrationLoading, setregistrationLoading] = useState(false);
    const [otpVerifying, setotpVerifying] = useState(false);
    const [otpVerified, setotpVerified] = useState(false);
    const [settingUpUser, setsettingUpUser] = useState(false);

    // Formik for phone number
    const phoneFormik = useFormik({
        initialValues: {
            phoneNumber: "",
        },
        validationSchema: Yup.object({
            phoneNumber: Yup.string()
                .matches(/^\d{10}$/, "Phone number must be 10 digits")
                .required("Phone number is required"),
        }),
        onSubmit: async (values) => {
            // handleRegistrationForm();
            setpreviousPhoneNUmber(phoneFormik.values.phoneNumber)
            handdleCheckUser()
        },
    });

    // Formik for OTP
    const otpFormik = useFormik({
        initialValues: {
            otp: "",
        },
        validationSchema: Yup.object({
            otp: Yup.string().required("OTP is required"),
        }),
        onSubmit: async (values) => {
            console.log("Verifying OTP:", values.otp);
            handleVerifyOtp();
        },
    });

    const passwordFormik = useFormik({
        initialValues: {
            password: "",
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(8, "Password must be at least 8 characters")
                .required("Password is required")
                .matches(
                    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
                    "Password must be at least 8 characters and include 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character"
                )
                .min(8, "Minimum 8 characters")
                .max(16, "Maximum 16 characters"),
        }),
        onSubmit: async (values) => {
            console.log("Verifying password:", values.password);
            handleLogin();
        },
    });


    const handdleCheckUser = catchAsync(async () => {
        setisLoading(true);
        return await axiosInstance.post("/user/exists", {
            mobileNumber: phoneFormik.values.phoneNumber
        })
    }, (result: any) => {
        // console.log({ result });

        if (IS_SUCCESS_RESPONSE(result)) {
            setisUserExists(result?.data?.isExists ? "Registered" : "Not-Registered")
            if (!result?.data?.isExists) {
                handleRegistrationForm()
            }
            // if (result?.isExists) {
            setisLoading(false);

            // }
        }
    }, () => { setisLoading(false); })

    const handleRegistrationForm = catchAsync(
        async () => {
            setisLoading(true);
            setregistrationLoading(true)
            return await registrationRequestApi({
                mobileNumber: phoneFormik.values.phoneNumber?.toString(),
                password: 'Test@1234',
                role: USER_ROLES.BD_EXECUTIVE,
            });
        },
        (result: AxiosResponse) => {
            if (IS_SUCCESS_RESPONSE(result)) {
                setOtpSent(true);
                startTimer();
                toast.success("Registration successful! OTP has been sent to your WhatsApp number.", {
                    style: successTheme,
                });
            }

            setisLoading(false);
            setregistrationLoading(false)
        },
        () => {
            setisLoading(false);
        }
    );

    const handleLogin = catchAsync(async () => {
        return await loginRequestApi({
            mobileNumber: phoneFormik.values.phoneNumber,
            password: passwordFormik.values.password
        });
    },
        (result: any) => {
            if (IS_SUCCESS_RESPONSE(result)) {
                const { accessToken, userid, mobileNumber, role, firstName, lastName, _id } = result.data;
                saveAuth({
                    api_token: accessToken,
                    user_id: _id,
                });

                setCurrentUser({
                    mobileNumber: mobileNumber,
                    id: _id,
                    name: firstName + " " + lastName,
                    access_token: accessToken,
                    role: role,
                    user_id: userid,
                });
            }
        },
        () => { })


    const startTimer = async () => {
        try {
            // Start the timer after OTP is sent successfully
            setTimer(180); // 3 minutes in seconds
            const countdown = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer <= 1) {
                        clearInterval(countdown);
                        setCanResend(true);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);
        } catch (error) {
            // Handle error, possibly allowing a retry
        }
    };

    const handleVerifyOtp = catchAsync(
        async () => {
            setotpVerifying(true);
            return await verifyOtpRequestApi({ otp: otpFormik.values.otp?.toString(), mobileNumber: phoneFormik.values.phoneNumber?.toString() });
        },
        (result: any) => {
            if (IS_SUCCESS_RESPONSE(result)) {
                setotpVerifying(false);
                setotpVerified(true)
                setsettingUpUser(true)
                console.log("OTP Verified successfully:", result.data);
                toast.success("OTP Verified successfully.", { style: successTheme });
                setAuth({
                    user_id: "",
                    api_token: result?.token
                })
                setTimeout(() => {
                    handleSetCurrentUser()
                }, 2000);

                // navigate("/");
            }
        },
        () => {
            setotpVerifying(false);
        }
    );

    const ResendOTP = catchAsync(
        async () => {
            setresentOtpisLoading(true);
            return await otpResentRequestApi({ mobileNumber: phoneFormik.values.phoneNumber?.toString() });
        },
        (result: any) => {
            if (IS_SUCCESS_RESPONSE(result)) {
                setCanResend(false);
                startTimer();
                toast.success("OTP Sent successfully, please check your inbox", { style: successTheme });
                setresentOtpisLoading(false);
            }
        },
        () => {
            setresentOtpisLoading(false);
        }
    );

    const handleSetCurrentUser = catchAsync(async () => {
        setsettingUpUser(true)
        return getUserByTokenRequestApi()
    }, (result: any) => {
        if (IS_SUCCESS_RESPONSE(result)) {
            const respData = result?.data;
            result &&
                setCurrentUser({
                    email: respData?.email,
                    id: respData?._id,
                    name: respData?.firstName + " " + respData?.lastName,
                    role: respData?.role,
                    access_token: respData?.accessToken,
                    user_id: respData?.userid,
                });
        }
        setsettingUpUser(false)
    }, () => { setsettingUpUser(false) })



    return (
        <div
            className="relative w-full h-screen bg-cover  flex items-center justify-center"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >

            <div className="space-y-4 max-w-sm mx-auto mt-10 bg-white p-10 rounded-lg shadow-md">
                <p className="text-center">Please login to see project details.</p>
                <form onSubmit={phoneFormik.handleSubmit}  >
                    <div className="flex space-x-2">
                        <div className="flex-1 ">
                            <Input
                                type="text"
                                placeholder="Enter Phone Number"
                                name="phoneNumber"
                                value={phoneFormik.values.phoneNumber}
                                onChange={phoneFormik.handleChange}
                            />
                            {phoneFormik.errors.phoneNumber && phoneFormik.touched.phoneNumber && (
                                <p className="text-red-500 text-sm">{phoneFormik.errors.phoneNumber}</p>
                            )}
                        </div>
                        {
                            (!isUserExists || phoneFormik.values.phoneNumber !== previousPhoneNUmber) ? <div className="">
                                <Button className="  flex space-x-2 w-full" disabled={isLoading} type="submit">
                                    {isLoading ? <span> <Loader2Icon className="animate-spin" size={20} /></span> : <></>}
                                    <span>Continue</span>
                                </Button>
                            </div> : <></>
                        }
                    </div>
                </form>
                {registrationLoading ? <div className="py-4 text-xs">
                    <div className="flex justify-center items-center ">
                        <div className="flex space-x-2">  <Loader2Icon className="animate-spin" />
                            <div>Loading...</div></div>
                    </div>
                </div> : <></>}
                {isUserExists == "Not-Registered" && otpSent ? <form onSubmit={otpFormik.handleSubmit}>
                    <div className="grid gap-4">
                        <div className="mb-2">
                            <Input
                                type="text"
                                placeholder="Enter OTP"
                                name="otp"
                                value={otpFormik.values.otp}
                                onChange={otpFormik.handleChange}
                            />
                            {otpFormik.errors.otp && otpFormik.touched.otp && (
                                <p className="text-red-500 text-sm">{otpFormik.errors.otp}</p>
                            )}
                        </div>
                        <div className="timer">
                            {canResend ? (
                                <RoundedButton isLoading={resentOtpisLoading} onClick={ResendOTP} className="w-full">
                                    Re-Send OTP
                                </RoundedButton>
                            ) : (
                                <>
                                    {
                                        otpVerifying && !otpVerified ? <>
                                            <div className="flex justify-center items-center ">
                                                <div className="flex space-x-2">
                                                    <Loader2Icon className="animate-spin" />
                                                    <div>verifying....</div></div>
                                            </div>
                                        </> : (!settingUpUser && <RoundedButton isLoading={isLoading} onClick={handleVerifyOtp} className="w-full">
                                            Verify OTP :{" "}
                                            <span className="mx-2">
                                                {timer > 0 ? (
                                                    <>
                                                        {Math.floor(timer / 60)}:{timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                                                    </>
                                                ) : null}{" "}
                                            </span>{" "}
                                        </RoundedButton>)
                                    }
                                </>
                            )}
                        </div>
                        {/* <div className="col-span-2">
                                <Button type="submit">Verify OTP</Button>
                            </div> */}
                    </div>
                </form> : <></>}

                {isUserExists == "Registered" ?
                    <form onSubmit={passwordFormik.handleSubmit} >
                        <div className="flex space-x-2">
                            <div className="flex-1">
                                <Input
                                    type="text"
                                    placeholder="Enter Password"
                                    name="password"
                                    value={passwordFormik.values.password}
                                    onChange={passwordFormik.handleChange}
                                />
                                {passwordFormik.errors.password && passwordFormik.touched.password && (
                                    <p className="text-red-500 text-sm">{passwordFormik.errors.password}</p>
                                )}
                            </div>
                            <div className="">
                                <Button type="submit">Continue</Button>
                            </div>
                        </div>
                    </form> : <></>
                }

                {settingUpUser ? <div className="py-4 text-xs">
                    <div className="flex justify-center items-center ">
                        <div className="flex space-x-2">
                            <Loader2Icon className="animate-spin" />
                            <div>Almost done, loading...</div>
                        </div>
                    </div>
                </div> : <></>}

            </div>


            {/* {!isUserExists && otpSent ?
                <>{(
                    <div className="space-y-4 max-w-sm mx-auto mt-10  bg-white p-10 rounded-lg shadow-md">
                        <p className="text-center">You got OTP via WhatsApp please check your WhatsApp number.</p>

                    </div>
                )}</> : null} */}

            {/* {isUserExists ?
                <>{(
                    <div className="space-y-4 max-w-sm mx-auto mt-10  bg-white p-10 rounded-lg shadow-md">
                        <p className="text-center">Your already registered, please enter your password to continue.</p>

                    </div>
                )}</> : null} */}


            <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>OTP Verified</DialogTitle>
                    </DialogHeader>
                    <p className="text-center">Your phone number has been successfully verified!</p>
                </DialogContent>
            </Dialog>
        </div >
    );
};

export default PhoneNumberVerification;

